<template>
    <div class="sgame-odds-box" v-if="group">
        <p class="sgame-odds-header" v-if="group.canShowMarketName || overrideShowMarketName">{{getMarketNameFinal}}</p>
        <div class="sgame-odds-container">
            <div class="sgame-odds-content">
                <div class="sgame-odd" v-if="sportTree.markets[marketId].hasModifier">
                    <div class="sgame-odd-header">
                        {{
                            sportTree.markets[marketId].modifierName
                            | formatModifierName(
                                matchesIn[matchId],
                                specifiers,
                            )
                        }}
                    </div>
                    <div class="sgame-odd-value no-odd">{{sportTree.markets[marketId].modifierValue | formatModifierName(matchesIn[matchId], specifiers)}}</div>
                </div>
                    <Outcome
                    v-for="outcome in outcomesSorted"
                    v-bind:outcome="outcome"
                    v-bind:match="matchesIn[matchId]"
                    v-bind:key="`${outcome.outcomeHash}|single`"
                    v-bind:details="true" />
            </div>
            <div v-if="false" class="sgame-stats">
                <i class="iconset icon-statistic"></i>
            </div>
        </div>
    </div>
</template>

<script>
import
{
    mapGetters,
}
from 'vuex';
import { Common } from '@om-retail/vue-common';
import Outcome from '../../Outcome.vue';

export default
{
    name: 'MarketGroup',
    props: [
        'group',
        'matchId',
    ],
    components:
    {
        Outcome,
    },
    computed:
    {
        ...mapGetters([
            'sportTree',
            'matchesIn',
            'globals',
        ]),
        marketId()
        {
            return this.group.marketId;
        },
        specifiers()
        {
            return this.group.outcomes[0].specifiers;
        },
        getMarketDisplayFieldName()
        {
            let fieldOut = 'name';
            const field = 'matchDetailsMarket';

            if (this.globals.publicConfig != null
            && this.globals.publicConfig.website != null
            && this.globals.publicConfig.website.sportOfferMarketOutcomeSettings != null
            && this.globals.publicConfig.website.sportOfferMarketOutcomeSettings[field] != null)
            {
                fieldOut = this.globals.publicConfig.website.sportOfferMarketOutcomeSettings[field];
            }

            return fieldOut;
        },
        getMarketName()
        {
            let nameOut = 'not defined';

            if (this.sportTree.markets[this.marketId] != null
            && this.sportTree.markets[this.marketId][this.getMarketDisplayFieldName] != null)
            {
                nameOut = this.sportTree.markets[this.marketId][this.getMarketDisplayFieldName];
            }

            return nameOut;
        },
        getMarketNameFinal()
        {
            let nameOut = this.getMarketName;

            if (this.getMarketDisplayFieldName === 'name')
            {
                nameOut = Common.formatSpecName(
                    nameOut,
                    this.matchesIn[this.matchId],
                    this.specifiers,
                );
            }

            return nameOut;
        },
        outcomesSorted()
        {
            const outcomes = [
                ...this.group.outcomes,
            ];

            outcomes.stableSort((a, b) =>
            {
                const aOutcomeOrder = this.sportTree.outcomes[a.outcomeId].orderNum;
                const bOutcomeOrder = this.sportTree.outcomes[b.outcomeId].orderNum;

                if (aOutcomeOrder < bOutcomeOrder)
                {
                    return -1;
                }

                if (aOutcomeOrder > bOutcomeOrder)
                {
                    return 1;
                }

                return 0;
            });

            return outcomes;
        },
        overrideShowMarketName()
        {
            return this.getMarketName.includes('{') || this.getMarketName.includes('}');
        },
    },
};
</script>
